// extracted by css-extract-rspack-plugin
export default {"iconDefault":"tY8x6x"};